import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const PartnerConfigurationsViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.PartnerConfigurationsView],
}

export const partnerConfigurationsModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.PartnerConfigurationsModify],
}
